import { CoordinatorService } from './coordinator.service';
import { ScriptBase } from './script-base';
import { ScriptCitation } from './script-citation';
import { ScriptHitset } from './script-hitset';
import { XItem } from './x-item';

export class ScriptItem extends ScriptBase {
    #coords: CoordinatorService;
    #_xitem: XItem;

    constructor(coords: CoordinatorService, _xitem: XItem) {
        super(coords, _xitem);
        this.#coords = coords;
        this.#_xitem = _xitem;
    }

    get type() {
        return this.#_xitem.type;
    }

    get _tV() {
        return this.#_xitem.templateValues;
    }

    get(tag: string) {
        return this.#_xitem.get(tag);
    }

    set(tag: string, val: any) {
        this.#_xitem.set(tag, val);
    }

    clone() {
        return new ScriptItem(this.#coords, this.#_xitem.clone(this.#coords.uniqueId()));
    }

    toCollection(permitDuplicate = false) {
        const xitm = this.#_xitem.clone(this.#coords.uniqueId());
        if (!permitDuplicate) {
            const kSet = this.#coords.dataset$.main.keys;
            for (const k of this.#_xitem.keys) if (kSet.has(k)) return;
        }
        this.#coords.dataset$.main.importXitemLs([xitm]);
    }

    get weight() {
        return this.#_xitem.keywordSum;
    }

    has(tag: string) {
        switch (tag) {
            case 'attachment':
                return this.#_xitem.hasAttachment;
            case 'duplicate':
                return this.#_xitem.hasDuplicate;
            case 'patent':
                return this.#_xitem.isPatent;
            case 'comment':
                return this.#_xitem.hasComment;
            case 'duplicate':
                return this.#_xitem.hasDuplicate;
            default:
                return this.get(tag) !== undefined;
        }
    }

    get csl() {
        return this.#_xitem.csl;
    }

    get title() {
        return this.#_xitem.title;
    }

    get year() {
        return this.#_xitem.get('year') || null;
    }

    get abstract() {
        return this.#_xitem.abstract || '';
    }

    get authors(): string[] {
        return this.#_xitem.get('authorLs') || [];
    }

    highlight(tp: string) {
        return this.#_xitem.highlight(tp);
    }

    get isPatent() {
        return this.#_xitem.isPatent;
    }

    cite(params?: any) {
        return new ScriptCitation(this.#coords).cite(this, params);
    }

    hitset(isPreview = false) {
        const nH = new ScriptHitset(this.#coords, isPreview);
        return this._hitset(nH, new Set([this.#_xitem.id]), this.#_xitem.dataset?.isPreview);
    }

    log(prefix = 'Item') {
        console.log(`${prefix}: ${this.title}`);
        console.log(this.abstract);
        return this;
    }
    display(isPreview = false) {
        this.hitset(isPreview).display();
        return this;
    }

    get values() {
        return this.#_xitem.values;
    }
   
    get conditions() {
        return this.#_xitem.conditions;
    }

    get subsets() {
        return this.#_xitem.subsets;
    }

    get ratings() {
        return this.#_xitem.ratings;
    }

    get tags() {
        return this.#_xitem.tags;
    }
}
